export default {
	label: 'Viide | Viited',
	method: 'Meetme viited',
	addMethod: 'Lisa meetme viide',
	addModule: 'Lisa mooduli viide',
	placeholder: 'Sisesta URL...',
	module: 'Mooduli viited',
	title: 'Sisesta viite pealkiri...',
	missing: 'Viiteid pole',
	risk: 'Riskide viited',
	threat: 'Ohtude viited',
	vulnerability: 'Nõrkuste viited',
	add: 'Lisa viide',
	url: 'URL viited',
	document: 'Dokumendi viited',
	selectFile: 'Vali dokument',
	selectUrl: 'Vali URL',
}
